module.exports = __webpack_public_path__ + "img/C99A8B_491B0E_6E4136_8A4D28-256px.4bda80e5.png";